import { getCurrentOrg } from './getCurrentOrg';
import { DefaultService as BillingV2Service } from '../services/conversations-billing-v2';
import type {
  AgentBillingV2ResponseDto,
  AgentsBillingV2ResponseDto,
  PageConversationBillingV2ResponseDto,
} from '../services/conversations-billing-v2';

export type ConversationBilling = PageConversationBillingV2ResponseDto;
export type AgentsBilling = AgentsBillingV2ResponseDto;
export type AgentBilling = AgentBillingV2ResponseDto;

export type ConversationBillingPayload = {
  xOrganizationContext: string;
  agentId?: string;
  conversationId?: string;
  startTime?: string;
  endTime?: string;
  page?: number;
  size: number;
  sort?: Array<string>;
};

export type AgentsBillingPayload = {
  xOrganizationContext: string;
  startTime?: string;
  endTime?: string;
};

export type AgentBillingPayload = {
  xOrganizationContext: string;
  agentId: string;
  startTime?: string;
  endTime?: string;
};

export const getConversationBilling = async (
  payload: Omit<ConversationBillingPayload, 'xOrganizationContext'>
): Promise<ConversationBilling> => {
  return await BillingV2Service.getConversationBilling(
    getCurrentOrg(),
    payload.agentId,
    payload.conversationId,
    payload.startTime,
    payload.endTime,
    payload.page,
    payload.size,
    payload.sort?.[0]
  );
};

export const getAgentsBilling = async (
  payload: Omit<AgentsBillingPayload, 'xOrganizationContext'>
): Promise<AgentsBilling> => {
  return await BillingV2Service.getAgents(
    getCurrentOrg(),
    payload.startTime,
    payload.endTime
  );
};

export const getAgentBillingById = async (
  payload: Omit<AgentBillingPayload, 'xOrganizationContext'>
): Promise<AgentBilling> => {
  return await BillingV2Service.getAgent(
    getCurrentOrg(),
    payload.agentId,
    payload.startTime,
    payload.endTime
  );
};

export const getBillingLastRefreshedDate = async (): Promise<string> => {
  return await BillingV2Service.getLastRefreshedDate(getCurrentOrg());
};
